<template>
  <div class="country-card text-center shadow pa-3">
    <CountryFlag :code="baseCountry" />
    <p class="lead my-2">{{ $tt('brand.name') }} {{ shortenCountry(baseCountry) }}</p>
    <p class="mb-1">{{ address.text }}</p>
  </div>
</template>

<script setup lang="ts">
import { getBranchByCode } from '~/helpers/branch';
import type { BranchCode } from '~/types';

const props = defineProps<{
  branch: BranchCode;
}>();

const { baseCountry, address } = getBranchByCode(props.branch);
const { shortenCountry } = useFormat();
</script>

<style scoped lang="scss">
.country-card {
  border-radius: var(--border-r-md);
  flex: 1;
  max-width: 300px;
  span {
    font-size: 50px !important;
  }
  p {
    font-size: 16px;
  }
  .lead {
    font-size: 20px;
    font-weight: 500;
  }
}
@media (max-width: 850px) {
  .country-card {
    width: 100%;
    max-width: calc(100vw - (2 * var(--space-5)));
  }
}
</style>